// -----------------------------------------------------------------------------
// 業務運用状態 リデューサー
// -----------------------------------------------------------------------------
import {combineReducers} from 'redux';
import types from './types';

/**
 * 現在の運用状態
 *
 * @param {Object} state - 現在の状態
 * @param {Object} action - アクション
 * @return {Object} 更新された状態
 */
const current = (state = null, action) => {
  switch (action.type) {
    case types.UPDATE_STATUS:
      return action.current || null;
    default: return state;
  }
};

/**
 * 近々の運用状態
 *
 * @param {Object} state - 現在の状態
 * @param {Object} action - アクション
 * @return {Object} 更新された状態
 */
const coming = (state = null, action) => {
  switch (action.type) {
    case types.UPDATE_STATUS:
      return action.coming || null;
    case types.CLEAR_COMING:
      return null;
    default: return state;
  }
};

// -----------------------------------------------------------------------------
// エクスポート
// -----------------------------------------------------------------------------
const reducers = combineReducers({
  current,    // 現在の運用状態
  coming,     // 近々の運用状態
});
export default reducers;
